import React from 'react';
import { LuChevronLeft, LuChevronRight } from 'react-icons/lu';
import './Pagination.less';

function buildPageWindow(page, totalPages) {
  if (totalPages <= 5) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }
  if (page <= 3) return [1, 2, 3, 4, 5];
  if (page >= totalPages - 2) {
    return [totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
  }
  return [page - 2, page - 1, page, page + 1, page + 2];
}

export default function Pagination({
  page,
  totalPages,
  onChange,
  ariaLabel = 'Pagination',
}) {
  if (!totalPages || totalPages <= 1) return null;

  const canPrev = page > 1;
  const canNext = page < totalPages;
  const window = buildPageWindow(page, totalPages);

  return (
    <nav className="gc-pagination" aria-label={ariaLabel}>
      <button
        type="button"
        className="gc-pagination-arrow"
        onClick={() => canPrev && onChange(page - 1)}
        disabled={!canPrev}
        aria-label="Previous page"
      >
        <LuChevronLeft aria-hidden="true" />
        <span>Previous</span>
      </button>

      <ol className="gc-pagination-pages" role="list">
        {window.map((p) => (
          <li key={p}>
            <button
              type="button"
              className={
                p === page
                  ? 'gc-pagination-page gc-pagination-page--active'
                  : 'gc-pagination-page'
              }
              onClick={() => p !== page && onChange(p)}
              aria-current={p === page ? 'page' : undefined}
              aria-label={`Page ${p}`}
            >
              {p}
            </button>
          </li>
        ))}
      </ol>

      <span className="gc-pagination-summary" aria-live="polite">
        Page {page} of {totalPages}
      </span>

      <button
        type="button"
        className="gc-pagination-arrow"
        onClick={() => canNext && onChange(page + 1)}
        disabled={!canNext}
        aria-label="Next page"
      >
        <span>Next</span>
        <LuChevronRight aria-hidden="true" />
      </button>
    </nav>
  );
}
